var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-modal",attrs:{"id":"video-modal"},on:{"click":_vm.close}},[_c('div',{staticClass:"close",on:{"click":_vm.close}},[_c('img',{attrs:{"src":"/chevron-down.svg","alt":"Close video"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }